/* eslint-disable prettier/prettier */

import { createSlice } from '@reduxjs/toolkit'

const reservationReducer = createSlice({
    name: 'reservationReducer',
    initialState: {
        availableRoomDetails: [],
        reservationDates: {
            startDate: new Date(),
            endDate: new Date(new Date().setDate(new Date().getDate() + 1)),
            roomType: '',
            room: '',
            key: 'selection',
        },
        bookingMethod: {},
        roomDetails: [
            {
                id: 1,
                roomType: '',
                room: '',
                stayType: '',
                adults: 0,
                children: 0,
                price: '',
                priceBreakDown: [],
            },
        ],
        contactDetails: [],
        specialRequest: '',
        errors: {},
        laterPayment: false,
        discountType: '%',
        payment: {
            type: 'Cash',
            totalAmount: 0.00,
            refferanceNo: '',
            paidAmount: 0.00,
            subTotal: 0.00,
            netTotal: 0.00,
            discount: 0.00,
            taxTotal: 0.00,
            date: new Date(),
        },
        bookingFromCalender: {
            status: false,
            data: {}
        }

    },
    reducers: {
        setField(state, action) {
            state[action.payload.name] = action.payload.value
        },
        setReservationDates(state, action) {
            state.reservationDates = action.payload;
        },
        addRoomDetail: (state, action) => {
            state.roomDetails.push(action.payload);
        },
        removeRoomDetail: (state, action) => {
            state.roomDetails.splice(action.payload, 1);
        },
        updateRoomDetails: (state, action) => {
            state.roomDetails = action.payload;
        },
        resetReservation: (state) => {
            state.reservationDates = {
                startDate: new Date(),
                endDate: new Date(new Date().setDate(new Date().getDate() + 1)),
                key: 'selection',
            };
            state.roomDetails = [
                {
                    id: 1,
                    roomType: '',
                    room: '',
                    stayType: '',
                    adults: 0,
                    children: 0,
                    price: '',
                    priceBreakDown: [],
                },
            ];
            state.errors = {};
            state.discount = 0;
            state.laterPayment = false;
            state.discountType = '%';
            state.payment = {
                type: 'Cash',
                totalAmount: 0.00,
                refferanceNo: '',
                paidAmount: 0.00,
                date: new Date(),
            };
            state.contactDetails = [];
            state.bookingMethod = {};
        },
        resetRooms: (state) => {
            state.roomDetails = [
                {
                    id: 1,
                    roomType: '',
                    room: '',
                    stayType: '',
                    adults: 0,
                    children: 0,
                    price: '',
                    priceBreakDown: [],
                },
            ];
            state.errors = {};
            state.laterPayment = false;
            state.discountType = '%';
            state.payment = {
                type: 'Cash',
                totalAmount: 0.00,
                refferanceNo: '',
                paidAmount: 0.00,
                subTotal: 0.00,
                netTotal: 0.00,
                discount: 0.00,
                taxTotal: 0.00,
                date: new Date(),
            };
        },
        resetForm: (state) => {
            state.contactDetails = [];
        },
        setRoomDetails: (state, action) => {
            state.roomDetails = action.payload;
        },
        setContacts(state, action) {
            state.contactDetails = action.payload;
        },
        setContactDetails: (state, action) => {
            state.contactDetails.push(action.payload);
        },
        removeContactDetailByIndex: (state, action) => {
            const index = action.payload;
            if (index >= 0 && index < state.contactDetails.length) {
                state.contactDetails.splice(index, 1);
            }
        },
        setPayment(state, action) {
            const { field, value } = action.payload;
            state.payment[field] = value;
        },
        setBookingFromCalender(state, action) {
            state.bookingFromCalender = action.payload;
        },
    },
});

export const {
    setReservationDates,
    setField,
    addRoomDetail,
    removeRoomDetail,
    resetReservation,
    setRoomDetails,
    setContacts,
    updateRoomDetails,
    setPayment,
    setContactDetails,
    resetForm,
    resetRooms,
    setBookingFromCalender,
    removeContactDetailByIndex
} = reservationReducer.actions;
export default reservationReducer.reducer;